<div class="s__faq-block" aria-label="Frequently asked questions">
  @for (item of items(); track $index) {
    <ds-faq-item [question]="item.question" [answer]="item.answer" />
  }
</div>
